export const SET_REDIRECT_PATH = "axa/SET_REDIRECT_PATH";

export const setRedirectPath = redirectPath => {
  return { type: SET_REDIRECT_PATH, payload: redirectPath };
};
